<template>
  <div class="w-full max-w-5xl px-4 sm:px-6 z-30">
    <form
      @submit.prevent="handleSearch"
      class="w-full bg-white rounded-2xl shadow-xl p-4 flex flex-col gap-4 md:flex-row md:items-center ring-1 ring-gray-200"
      role="search"
    >
      <!-- Champ : Que cherchez-vous -->
      <div class="flex-1 w-full">
        <label for="search-name" class="block text-sm text-gray-600 mb-1">
          Que cherchez-vous ?
        </label>
        <input
          id="search-name"
          type="text"
          placeholder="Nom du salon, prestations (coupe...)"
          class="w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-base"
          v-model="query"
        />
      </div>

      <!-- Champ : Où avec autocomplétion -->
      <div class="flex-1 w-full relative">
        <label for="search-location" class="block text-sm text-gray-600 mb-1">
          Où
        </label>
        <input
          id="search-location"
          type="text"
          placeholder="Adresse, ville..."
          class="w-full px-3 py-2 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-indigo-500 text-base"
          v-model="location"
          @input="fetchSuggestions"
          @blur="onBlur"
          @focus="onFocus"
          autocomplete="off"
        />

        <!-- Suggestions -->
        <ul
          v-if="showSuggestions && suggestions.length > 0"
          class="absolute bg-white border border-gray-300 rounded-lg w-full max-h-60 overflow-auto mt-1 z-50"
        >
          <li
            v-for="(item, index) in suggestions"
            :key="index"
            class="px-4 py-2 hover:bg-indigo-100 cursor-pointer"
            @mousedown.prevent="selectSuggestion(item.description)"
          >
            {{ item.description }}
          </li>
        </ul>
        
      </div>

      <!-- Bouton Rechercher -->
      <div class="w-full md:w-auto">
        <button
          type="submit"
          class="bg-[#18b7bd] text-white w-full md:w-auto px-6 py-2 rounded-lg hover:bg-gray-800 transition-colors text-base font-semibold"
        >
          Rechercher
        </button>
      </div>
      
    </form>
    <p v-if="errorLocation" class="text-red-500 text-sm mt-1">Le champ Lieux est requis</p>

  </div>
</template>


<script>
import axios from 'axios'
import _ from 'lodash'

export default {
  data() {
    return {
      query: '',
      location: '',
      suggestions: [],
      showSuggestions: false,
      fetchSuggestionsDebounced: null,
      errorLocation: false,
    }
  },
  created() {
    // Pour limiter les appels API : debounce (attente 300ms après dernière saisie)
    this.fetchSuggestionsDebounced = _.debounce(this.fetchSuggestions, 300)
  },
  methods: {
handleSearch() {
  if (!this.location.trim()) {
    this.errorLocation = true;
    return;
  }
  this.errorLocation = false;

  const params = {};
  if (this.query.trim()) params.query = this.query.trim();
  params.location = this.location.trim();

  this.$router.push({ path: '/search', query: params });
},
    fetchSuggestions() {
      const input = this.location.trim()
      if (input.length < 2) {
        this.suggestions = []
        return
      }
      // Appel à ton backend proxy Google Places
      axios
        .get('https://b53c7d5edf32.ngrok-free.app/api/google-cities-autocomplete', { params: { input } })
        .then(res => {
          this.suggestions = res.data.predictions || []
          this.showSuggestions = true
        })
        .catch(() => {
          this.suggestions = []
          this.showSuggestions = false
        })
    },
    selectSuggestion(description) {
      this.location = description
      this.showSuggestions = false
    },
    onBlur() {
      // Cache la liste au blur après un petit délai (sinon clic sur suggestion ne fonctionne pas)
      setTimeout(() => {
        this.showSuggestions = false
      }, 150)
    },
    onFocus() {
      if (this.suggestions.length > 0) {
        this.showSuggestions = true
      }
    }
  },
  watch: {
    location() {
      this.fetchSuggestionsDebounced()
    }
  }
}
</script>
